/**
 * FS | Style Swipe - storefront card game (see sections/style-swipe.liquid).
 *
 * Talks to the Full-Story-Utilities app proxy:
 *   GET  data-proxy-feed  -> { ok, enabled, cards[], progress }
 *   POST data-proxy-rate  -> { ok, counted, duplicate, entryEarned, progress }
 * Identity is Shopify's signed logged_in_customer_id proxy param (session
 * cookie), so requests are plain same-origin fetches - nothing secret here.
 *
 * Pre-launch preview gate: obscurity only, the server enforces the real rules.
 */
(function () {
  var root = document.querySelector('[data-pwtss-root]');
  if (!root || root.__pwtss) return;
  root.__pwtss = true;

  // ── config ─────────────────────────────────────────────────────────────
  var feedUrl = root.getAttribute('data-proxy-feed') || '/apps/fullstory/swipe/feed';
  var rateUrl = root.getAttribute('data-proxy-rate') || '/apps/fullstory/swipe/rate';
  var previewMode = root.getAttribute('data-preview-mode') === '1';
  var previewKey = root.getAttribute('data-preview-key') || '';
  var designMode = root.getAttribute('data-design-mode') === '1';
  var loggedIn = root.getAttribute('data-logged-in') === '1';
  var firstName = root.getAttribute('data-first-name') || '';
  var STORAGE_KEY = 'pwtss_preview';

  var config = { reasons: [] };
  try {
    var island = root.querySelector('[data-pwtss-config]');
    if (island) config = JSON.parse(island.textContent) || config;
  } catch (e) { /* defaults stand */ }

  // ── preview gate ───────────────────────────────────────────────────────
  function previewUnlocked() {
    if (!previewMode || designMode) return true;
    if (!previewKey) return false;
    var fromUrl = new URLSearchParams(location.search).get('preview');
    if (fromUrl === previewKey) {
      try { sessionStorage.setItem(STORAGE_KEY, previewKey); } catch (e) { /* private mode */ }
      return true;
    }
    try { return sessionStorage.getItem(STORAGE_KEY) === previewKey; } catch (e) { return false; }
  }

  if (!previewUnlocked()) return; // coming-soon stays; app stays hidden

  var soon = root.querySelector('[data-ss-comingsoon]');
  if (soon) soon.hidden = true;
  var app = root.querySelector('[data-ss-app]');
  if (app) app.hidden = false;

  // Keep the gate open through the login round-trip. New customer accounts
  // honor return_to on /customer_authentication/login (relative URLs only).
  var loginLink = root.querySelector('[data-ss-login-link]');
  if (loginLink && previewMode && previewKey) {
    loginLink.href = '/customer_authentication/login?return_to=' +
      encodeURIComponent(location.pathname + '?preview=' + previewKey);
  }

  if (!loggedIn) return; // server-rendered login panel does the rest

  // ── elements ───────────────────────────────────────────────────────────
  var deckEl = root.querySelector('[data-ss-deck]');
  var actionsEl = root.querySelector('[data-ss-actions]');
  var progressEl = root.querySelector('[data-ss-progress]');
  var overlayEl = root.querySelector('[data-ss-reasons]');
  var chipRowEl = root.querySelector('[data-ss-chiprow]');
  var toastEl = root.querySelector('[data-ss-toast]');
  var lastEl = root.querySelector('[data-ss-last]');
  var states = {
    loading: root.querySelector('[data-ss-loading]'),
    error: root.querySelector('[data-ss-error]'),
    done: root.querySelector('[data-ss-done]'),
    paused: root.querySelector('[data-ss-paused]')
  };
  if (!deckEl) return;

  // ── state ──────────────────────────────────────────────────────────────
  var deck = [];            // cards waiting to be shown (deck[0] = on top)
  var ratedIds = {};        // mediaId -> true for this session
  var shownAt = 0;          // timestamp the current top card appeared
  var busy = false;         // exit animation in flight
  var pending = null;       // dislike awaiting a reason chip
  var pendingTimer = 0;
  var fetching = false;
  var feedExhausted = false;
  var sendQueue = [];       // failed payloads for pagehide beacon flush
  var toastTimer = 0;

  // ── helpers ────────────────────────────────────────────────────────────
  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function showState(name) {
    Object.keys(states).forEach(function (key) {
      if (states[key]) states[key].hidden = key !== name;
    });
    if (actionsEl) actionsEl.hidden = name !== null;
  }

  function hideStates() {
    Object.keys(states).forEach(function (key) {
      if (states[key]) states[key].hidden = true;
    });
    if (actionsEl) actionsEl.hidden = false;
  }

  function toast(message, win) {
    if (!toastEl) return;
    toastEl.textContent = message;
    toastEl.classList.toggle('pwtss-toast--win', Boolean(win));
    toastEl.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.hidden = true; }, win ? 3800 : 2600);
  }

  function inDeck(mediaId) {
    for (var i = 0; i < deck.length; i += 1) {
      if (deck[i].mediaId === mediaId) return true;
    }
    return false;
  }

  // ── progress ───────────────────────────────────────────────────────────
  function updateProgress(progress) {
    if (!progress || !progressEl) return;
    progressEl.hidden = false;

    var greeting = progressEl.querySelector('[data-ss-greeting]');
    if (greeting) greeting.textContent = firstName ? 'hey ' + firstName.toLowerCase() : 'hey you';

    var entries = progressEl.querySelector('[data-ss-entries]');
    if (entries) entries.textContent = String(progress.entriesThisMonth);
    var entriesLabel = progressEl.querySelector('[data-ss-entries-label]');
    if (entriesLabel) {
      entriesLabel.textContent = (progress.entriesThisMonth === 1 ? 'entry' : 'entries');
    }

    var bar = progressEl.querySelector('[data-ss-bar]');
    if (bar && progress.entryThreshold > 0) {
      var into = progress.entryThreshold - progress.toNextEntry;
      bar.style.width = Math.round((into / progress.entryThreshold) * 100) + '%';
    }

    var toNext = progressEl.querySelector('[data-ss-tonext]');
    if (toNext) {
      toNext.textContent = progress.toNextEntry + ' more to your next entry';
    }
    var daily = progressEl.querySelector('[data-ss-daily]');
    if (daily) {
      daily.textContent = progress.dailyRemaining <= 15
        ? progress.dailyRemaining + ' counted swipes left today'
        : '';
    }
  }

  // ── deck rendering ─────────────────────────────────────────────────────
  function buildCardEl(card, depth) {
    var el = document.createElement('article');
    el.className = 'pwtss-card';
    el.setAttribute('data-media-id', card.mediaId);
    if (depth > 0) el.setAttribute('data-depth', String(depth));
    else el.classList.add('is-top');
    el.innerHTML =
      '<img src="' + esc(card.imageUrl) + '" alt="' + esc(card.altText || card.productTitle) + '" draggable="false">' +
      '<div class="pwtss-card__meta">' + esc(card.productTitle) + '</div>' +
      '<span class="pwtss-card__stamp pwtss-card__stamp--like" data-stamp-like>love it</span>' +
      '<span class="pwtss-card__stamp pwtss-card__stamp--nope" data-stamp-nope>not for me</span>';
    return el;
  }

  function renderDeck() {
    // Keep exiting cards (they animate out above the stack), rebuild the rest.
    var children = Array.prototype.slice.call(deckEl.children);
    children.forEach(function (child) {
      if (!child.classList.contains('is-exit')) child.remove();
    });

    if (deck.length === 0) {
      if (feedExhausted) showState('done');
      return;
    }

    hideStates();
    var visible = deck.slice(0, 3);
    for (var i = visible.length - 1; i >= 0; i -= 1) {
      var el = buildCardEl(visible[i], i);
      deckEl.appendChild(el); // top card appended last = on top
      if (i === 0) bindDrag(el);
    }
    shownAt = performance.now();
  }

  function topCardEl() {
    var cards = deckEl.querySelectorAll('.pwtss-card.is-top:not(.is-exit)');
    return cards.length ? cards[cards.length - 1] : null;
  }

  // ── gestures ───────────────────────────────────────────────────────────
  function bindDrag(el) {
    var startX = 0;
    var startY = 0;
    var dx = 0;
    var dy = 0;
    var lastX = 0;
    var lastT = 0;
    var vx = 0;
    var dragging = false;
    var likeStamp = el.querySelector('[data-stamp-like]');
    var nopeStamp = el.querySelector('[data-stamp-nope]');

    el.addEventListener('pointerdown', function (e) {
      if (busy || pending) return;
      dragging = true;
      dx = 0; dy = 0; vx = 0;
      startX = e.clientX; startY = e.clientY;
      lastX = e.clientX; lastT = performance.now();
      el.classList.remove('is-reset');
      try { el.setPointerCapture(e.pointerId); } catch (err) { /* older safari */ }
    });

    el.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      dx = e.clientX - startX;
      dy = e.clientY - startY;
      var now = performance.now();
      vx = (e.clientX - lastX) / Math.max(now - lastT, 1);
      lastX = e.clientX; lastT = now;
      el.style.transform =
        'translate(' + dx + 'px,' + dy * 0.25 + 'px) rotate(' + dx * 0.05 + 'deg)';
      if (likeStamp) likeStamp.style.opacity = dx > 0 ? Math.min(dx / 90, 1) : 0;
      if (nopeStamp) nopeStamp.style.opacity = dx < 0 ? Math.min(-dx / 90, 1) : 0;
    });

    function release() {
      if (!dragging) return;
      dragging = false;
      if (dx > 90 || vx > 0.6) {
        commit('like', el);
      } else if (dx < -90 || vx < -0.6) {
        commit('dislike', el);
      } else {
        el.classList.add('is-reset');
        el.style.transform = '';
        if (likeStamp) likeStamp.style.opacity = 0;
        if (nopeStamp) nopeStamp.style.opacity = 0;
      }
    }

    el.addEventListener('pointerup', release);
    el.addEventListener('pointercancel', release);
  }

  // ── committing a verdict ───────────────────────────────────────────────
  function commit(verdict, el) {
    if (busy || pending || deck.length === 0) return;
    busy = true;

    var card = deck.shift();
    ratedIds[card.mediaId] = true;
    var dwellMs = Math.round(performance.now() - shownAt);

    var like = verdict === 'like';
    el.classList.add('is-exit');
    el.style.zIndex = '5';
    el.style.transform =
      'translate(' + (like ? '120%' : '-120%') + ',-6%) rotate(' + (like ? 16 : -16) + 'deg)';
    var stamp = el.querySelector(like ? '[data-stamp-like]' : '[data-stamp-nope]');
    if (stamp) stamp.style.opacity = 1;
    setTimeout(function () { el.remove(); }, 440);

    updateLast(card);

    if (like) {
      sendRate(card, 'like', null, dwellMs);
    } else {
      openReasons(card, dwellMs);
    }

    busy = false;
    renderDeck();
    if (deck.length < 5) loadFeed();
  }

  function updateLast(card) {
    if (!lastEl) return;
    lastEl.hidden = false;
    lastEl.innerHTML =
      'just rated: ' + esc(card.productTitle) +
      ' &middot; <a href="/products/' + esc(card.productHandle) + '" target="_blank" rel="noopener">view product</a>';
  }

  // ── dislike reasons ────────────────────────────────────────────────────
  function renderChips() {
    if (!chipRowEl) return;
    var html = '';
    (config.reasons || []).forEach(function (reason) {
      html += '<button type="button" class="pwtss-chip" data-reason="' + esc(reason.slug) + '">' +
        esc(reason.label) + '</button>';
    });
    chipRowEl.innerHTML = html;
  }

  function openReasons(card, dwellMs) {
    if (!overlayEl) {
      sendRate(card, 'dislike', null, dwellMs);
      return;
    }
    pending = { card: card, dwellMs: dwellMs };
    overlayEl.hidden = false;
    clearTimeout(pendingTimer);
    pendingTimer = setTimeout(function () { resolveReason(null); }, 6000);
  }

  function resolveReason(slug) {
    if (!pending) return;
    clearTimeout(pendingTimer);
    overlayEl.hidden = true;
    var held = pending;
    pending = null;
    sendRate(held.card, 'dislike', slug, held.dwellMs);
  }

  // ── server calls ───────────────────────────────────────────────────────
  function loadFeed() {
    if (fetching || feedExhausted) return;
    fetching = true;
    fetch(feedUrl, { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (res.status === 401) throw { authError: true };
        if (!res.ok) throw new Error('feed http ' + res.status);
        return res.json();
      })
      .then(function (data) {
        fetching = false;
        if (!data || !data.ok) throw new Error('feed body');
        if (data.enabled === false) { showState('paused'); return; }
        updateProgress(data.progress);
        var added = 0;
        (data.cards || []).forEach(function (card) {
          if (!inDeck(card.mediaId) && !ratedIds[card.mediaId]) {
            deck.push(card);
            added += 1;
          }
        });
        if (added === 0 && deck.length === 0) {
          feedExhausted = true;
          showState('done');
          return;
        }
        if (deckEl.querySelectorAll('.pwtss-card:not(.is-exit)').length === 0) renderDeck();
      })
      .catch(function (err) {
        fetching = false;
        if (deck.length > 0) return; // keep playing; retry on next prefetch
        if (err && err.authError) {
          var errState = states.error;
          if (errState) {
            var msg = errState.querySelector('p');
            if (msg) msg.textContent = 'your session expired - log in again to keep playing.';
          }
        }
        showState('error');
      });
  }

  function sendRate(card, verdict, reason, dwellMs) {
    var payload = { mediaId: card.mediaId, verdict: verdict, reason: reason, dwellMs: dwellMs };
    postRate(payload, 0);
  }

  function postRate(payload, attempt) {
    fetch(rateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (res.status >= 500) throw new Error('rate http ' + res.status);
        return res.json().then(function (data) { return { status: res.status, data: data }; });
      })
      .then(function (result) {
        var data = result.data || {};
        if (result.status === 429) { toast('easy - give it a second between swipes'); return; }
        if (!data.ok) return; // validation/auth: nothing useful to retry
        updateProgress(data.progress);
        if (data.entryEarned) {
          toast("that's an entry. you are perfect.", true);
        } else if (data.counted === false && data.progress && data.progress.dailyRemaining === 0) {
          toast("daily cap reached - extra swipes today won't count");
        }
      })
      .catch(function () {
        if (attempt < 3) {
          setTimeout(function () { postRate(payload, attempt + 1); }, 700 * Math.pow(2, attempt));
        } else {
          sendQueue.push(payload);
        }
      });
  }

  // Server-side dedupe makes replays safe, so flush stragglers on exit.
  window.addEventListener('pagehide', function () {
    if (!sendQueue.length || !navigator.sendBeacon) return;
    sendQueue.forEach(function (payload) {
      navigator.sendBeacon(rateUrl, new Blob([JSON.stringify(payload)], { type: 'application/json' }));
    });
    sendQueue = [];
  });

  // ── events ─────────────────────────────────────────────────────────────
  root.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-reason]');
    if (chip) { resolveReason(chip.getAttribute('data-reason')); return; }
    if (e.target.closest('[data-ss-skip]')) { resolveReason(null); return; }
    if (e.target.closest('[data-ss-retry]')) {
      showState('loading');
      feedExhausted = false;
      loadFeed();
      return;
    }
    var likeBtn = e.target.closest('[data-ss-like]');
    var nopeBtn = e.target.closest('[data-ss-nope]');
    if (likeBtn || nopeBtn) {
      var el = topCardEl();
      if (el) commit(likeBtn ? 'like' : 'dislike', el);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.target && /^(input|textarea|select)$/i.test(e.target.tagName || '')) return;
    if (pending) {
      if (e.key === 'Escape') resolveReason(null);
      return;
    }
    if (deck.length === 0) return;
    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
      var el = topCardEl();
      if (el) commit(e.key === 'ArrowRight' ? 'like' : 'dislike', el);
    }
  });

  // ── init ───────────────────────────────────────────────────────────────
  renderChips();
  if (designMode) {
    // Theme editor renders the layout only; the proxy needs a real login.
    var msg = states.error && states.error.querySelector('p');
    if (msg) msg.textContent = 'editor preview: the game loads for logged-in customers on the storefront.';
    var retry = states.error && states.error.querySelector('[data-ss-retry]');
    if (retry) retry.hidden = true;
    showState('error');
  } else {
    showState('loading');
    loadFeed();
  }
})();
